import React, { useRef, useEffect, useState } from 'react';
import moment from 'moment';
import base64Logo from '../../assets/base64.js'
import { getLogo } from "../../api";

const ThermalInvoice = ({ userProfile, invoice, isTaxCopy, triggerPrint }) => {
  const printRef = useRef();

  const [loading, setLoading] = useState(false);
  const [existingLogo, setExistingLogo] = useState(null);

  useEffect(() => {
    const fetchLogo = async () => {
      setLoading(true);
      try {
        const { data } = await getLogo();

        if (data?.logoBase64) {
          setExistingLogo(`data:image/png;base64,${data.logoBase64}`);
        }
      } catch (err) {
        console.error("Failed to load logo:", err);
      }
      setLoading(false);
    };

    fetchLogo();
  }, []);

  useEffect(() => {
    // Auto-print when isPrintBill (checkout flow) or when triggerPrint (reprint from InvoiceDetails)
    if (invoice?.isPrintBill || triggerPrint) {
      handlePrint();
    }
  }, [invoice?.isPrintBill, triggerPrint]);

  const getPrintCount = () => {
    const setting = localStorage.getItem("invoicePrintCount");
    return setting === "SINGLE" ? 1 : 2;
  };

  const printOnce = (copyLabel) => {
    return new Promise((resolve) => {
      const printContent = document.getElementById('thermal-invoice');
      if (!printContent) {
        console.error("ThermalInvoice: print root not found");
        resolve();
        return;
      }
      
      // Create an iframe element
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      document.body.appendChild(iframe);
      
      // Write content to iframe with copy label
      const iframeDoc = iframe.contentWindow.document;
      let contentHtml = printContent.innerHTML;
      
      // Replace copy label if exists
      if (copyLabel) {
        contentHtml = contentHtml.replace(
          />Customer Copy</,
          `>${copyLabel}<`
        ).replace(
          />Tax Copy</,
          `>${copyLabel}<`
        );
      }
      
      iframeDoc.write('<!DOCTYPE html><html><head><title>Print Invoice</title>'
        + '<style>'
        + '@page { size: 80mm auto; margin: 0mm 5mm 0mm 5mm; }'
        + '@media print {'
        + '  body { margin: 0; padding: 0; width: 80mm; }'
        + '  .invoice-wrapper { width: 72mm; padding: 1mm 4mm; font-family: "Arial", sans-serif; }'
        + '  .text-center { text-align: center; }'
        + '  .text-right { text-align: right; }'
        + '  .bold { font-weight: bold; }'
        + '  .divider { border-bottom: 1px dotted #000; margin: 5px 0; }'
        + '  table { width: 100%; border-collapse: collapse; }'
        + '  th, td { padding: 2px 0; }'
        + '  .items-table th { font-size: 18px; }'
        + '  .items-table td { font-size: 16px; }'
        + '  .total-amount { font-size: 24px; }'
        + '  .header-text { font-size: 18px; }'
        + '  .footer-text { font-size: 10px; }'
        + '}'
        + '</style></head><body>'
        + contentHtml
        + '</body></html>');
      iframeDoc.close();
      
      // Print the iframe
      iframe.contentWindow.onafterprint = () => {
        document.body.removeChild(iframe);
        resolve();
      };
      
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    });
  };

  const handlePrint = async () => {
    const copies = getPrintCount();
    const labels = copies === 2 ? ["Customer Copy", "Shop Copy"] : ["Customer Copy"];
    
    for (let i = 0; i < copies; i++) {
      await printOnce(labels[i]);
      // Small delay between prints
      if (i < copies - 1) {
        await new Promise(r => setTimeout(r, 500));
      }
    }
  };
  
  // const handlePrint = async () => {
  //   const printContent = document.getElementById('thermal-invoice');
  
  //   // Fetch logo before printing
  //   let logoBase64 = existingLogo; // use cached if available
  //   if (!logoBase64) {
  //     try {
  //       const { data } = await getLogo(); // API call
  //       logoBase64 = `data:image/png;base64,${data.logoBase64}`;
  //       setExistingLogo(logoBase64); // update state/cache
  //     } catch (err) {
  //       console.error("Failed to fetch logo:", err);
  //     }
  //   }
  
  //   // Replace <img> in the invoice temporarily with fetched logo
  //   if (printContent) {
  //     const img = printContent.querySelector("img");
  //     if (img && logoBase64) img.src = logoBase64;
  //   }
  
  //   // Create an iframe element
  //   const iframe = document.createElement('iframe');
  //   iframe.style.display = 'none';
  //   document.body.appendChild(iframe);
  
  //   // Write content to iframe
  //   const iframeDoc = iframe.contentWindow.document;
  //   iframeDoc.write('<!DOCTYPE html><html><head><title>Print Invoice</title>'
  //     + '<style>'
  //     + '@page { size: 80mm auto; margin: 0mm 5mm 0mm 5mm; }'
  //     + '@media print { body { margin: 0; padding: 0; width: 80mm; }'
  //     + ' .invoice-wrapper { width: 72mm; padding: 1mm 4mm; font-family: "Arial", sans-serif; }'
  //     + ' .text-center { text-align: center; }'
  //     + ' .text-right { text-align: right; }'
  //     + ' .bold { font-weight: bold; }'
  //     + ' .divider { border-bottom: 1px dotted #000; margin: 5px 0; }'
  //     + ' table { width: 100%; border-collapse: collapse; }'
  //     + ' th, td { padding: 2px 0; }'
  //     + ' .items-table th { font-size: 18px; }'
  //     + ' .items-table td { font-size: 16px; }'
  //     + ' .total-amount { font-size: 24px; }'
  //     + ' .header-text { font-size: 18px; }'
  //     + ' .footer-text { font-size: 10px; } }'
  //     + '</style></head><body>'
  //     + printContent.innerHTML
  //     + '</body></html>');
  //   iframeDoc.close();
  
  //   // Print the iframe
  //   iframe.contentWindow.onafterprint = () => {
  //     document.body.removeChild(iframe);
  //   };
  
  //   iframe.contentWindow.focus();
  //   iframe.contentWindow.print();
  // };

  return (
    <div id="thermal-invoice" className="invoice-wrapper" ref={printRef}>
      
      <div
        style={{
          width: "auto",
          padding: "5px 10px", 
          paddingTop: "0px", 
        }}
      >
        <img
          src={userProfile.logo}
          alt="Logo"
          style={{ width: "180px", margin: "0 auto", display: "block" }}
        />
      </div>

      <div className="text-center bold header-text">
        {isTaxCopy ? "Tax Copy" : "Customer Copy"}
      </div>
      <div className="text-center bold header-text">
        {userProfile.businessName}
      </div>
      <div className="text-center header-text">
        PHONE: {userProfile.phoneNumber}
      </div>
      <div className="divider" />
      
      <div className="text-center total-amount bold">
        ฿{invoice.total.toFixed(2)}
      </div>
      <div className="text-center">Total</div>
      
      <div className="divider" />
      
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <span>Bill To: {invoice?.client?.name || "Cash"}</span>
        <span>Invoice No: {invoice?.invoiceNumber}</span>
      </div>
      
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <span>Date: {moment(invoice.createdAt).format("DD-MM-YYYY")}</span>
        <span>Time: {moment(invoice.createdAt).format("hh:mm a")}</span>
      </div>
      
      <div className="divider" />
      
      <table className="items-table">
        <thead>
          <tr>
            <th style={{ width: '50%', textAlign: 'left' }}>Items</th>
            <th style={{ width: '20%', textAlign: 'center',whiteSpace: 'nowrap' }}>Qty</th>
            <th style={{ width: '30%', textAlign: 'right' }}>Amount</th>
          </tr>
        </thead>
        <tbody>
          {invoice?.items?.map((item, index) => {
            const unitAbbr =
              item?.item?.units?.sale?.unit?.abbreviation || "";
            const rate =
              parseFloat(
                item?.rate ?? item?.overridePrice ?? item?.item?.units?.sale?.price ?? 0
              ) || 0;
            const quantity = item?.quantity || 0;
            const lineAmount = quantity * rate;
            const firstRemark = (item?.remark || "").trim();

            return (
              <React.Fragment key={index}>
                <tr>
                  <td>{item?.item?.itemName}</td>
                  <td
                    className="text-center"
                    style={{
                      whiteSpace: "nowrap",
                    }}
                  >
                    {quantity}
                    {unitAbbr ? ` ${unitAbbr}` : ""}
                  </td>
                  <td className="text-right">
                    {lineAmount.toFixed(2)}
                  </td>
                </tr>
                {firstRemark && (
                  <tr>
                    <td colSpan={3} style={{ fontSize: "16px", color: "#444", paddingTop: "2px" }}>
                      Remark: {firstRemark}
                    </td>
                  </tr>
                )}
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
      
      <div className="divider" />
      
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <span>Sub-Total</span>
        <span>{invoice.subTotal.toFixed(2)}</span>
      </div>
      
      {invoice?.discount > 0 && (
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span>Discount</span>
          <span>฿{invoice.discount.toFixed(2)}</span>
        </div>
      )}
      
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <span>Tax</span>
        <span>฿{invoice.vat.toFixed(2)}</span>
      </div>
      
      <div className="divider" />
      
      <div style={{ display: 'flex', justifyContent: 'space-between' }} className="bold">
        <span>Amount Payable(฿)</span>
        <span>฿{invoice.total.toFixed(2)}</span>
      </div>
      
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <span>Pay Mode</span>
        <span>{invoice.paymentMode}</span>
      </div>
      
      {invoice.paymentMode === "Cash" && (
        <>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <span>Amount Paid</span>
            <span>{invoice.receivedAmount}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <span>Change</span>
            <span>{invoice.change}</span>
          </div>
        </>
      )}
      
      <div className="divider" />
      
      <div className="text-center bold">
        THANK YOU
      </div>
      
      <div className="text-center footer-text">
        Powered by: MindTree Technologies Co. Ltd.
      </div>
    </div>
  );
};

export default ThermalInvoice;